import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { GridPriceDetails } from '../../../SearchResult/components/GridPriceDetails/GridPriceDetails';
import { transformRateSelectorDataToSlide } from '../../../SearchResult/components/GridPriceDetails/helpers';
import PricingTableStyled from './styled';
import { useAttributionCategories } from '../../../../data/useSelectors';
import { useDisplayBuySideAdjustments } from '../../../../common/utils/customHooks/useDisplayBuySideAdjustments';

export const PricingTable = () => {
  const {
    lien: { adjustments = [], armIndexValue = null, arm = false } = {},
    loan: { mortgageType = '' } = {},
  } = useSelector(({ epps }) => epps.lockSummary.rateSelector || {});
  const heloc = useMemo(() => mortgageType === 'HELOC', [mortgageType]);
  const loanAdjustments = useDisplayBuySideAdjustments();
  const allCategories = useAttributionCategories();
  return (
    <PricingTableStyled
      fullWidth={arm || heloc}
      data-testid="PricingTable-all-components"
    >
      <GridPriceDetails
        data={{
          ...transformRateSelectorDataToSlide({
            pricingAdjustments: adjustments,
            armIndexValue,
            loanAdjustments,
            attributionCategories: [
              ...allCategories.adjustmentReasonCategories,
              ...allCategories.paidByCategories,
            ],
          }),
          showMarginTable: arm || heloc,
        }}
        showText={false}
      />
    </PricingTableStyled>
  );
};
